import axios from "axios";

/* axios.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response && error.response.status === 401) {
			window.history.pushState("", "home", "/");
			window.history.replaceState("", "home", "/");
			sessionStorage.clear();
			window.location.reload();
		}
		return Promise.reject(error);
	}
); */

const url = process.env.REACT_APP_BACKEND_HOST.concat("/spot/");

export async function deleteAdjustedClassId({ token, classid }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "delete",
			url: url + "delete_blue_courses_by_classid/".concat(`${classid}/`),

			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 204) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}
